export function parseAppointStatus(status) {
  return statusMap[status] || '';
}

export function getStatusClass(label) {
  return classMap[label] || '';
}

const statusMap = {
  18: '预留待确认',
  20: '待咨询',
  31: '来访者取消',
  36: '咨询师取消',
  40: '待确认',
  51: '来访者爽约',
  56: '咨询师爽约',
  80: '咨询完成',
  82: '咨询完成',
  88: '咨询完成',
  90: '咨询完成'
};

const classMap = {
  'wait': 'orange20',
  'waitConfirm': 'blue20',
  'cancelOrMiss': 'red20',
  'recorded': 'green20',
  'notRecord': 'green20'
};
